<template>
	<modal-dialog
		:modal-visible="visible"
		:title="title"
		confirm-button-text="Submit"
		v-on:closeModal="closeModal"
		v-on:confirm="saveTimeLog">

		<template v-if="recordType == 'clockIn'">
			<field
				label="User"
				v-model="user_id"
				col-class="col-md-4"
				:params="{type:'select',options:userOptions(false)}"
				v-on:change="fetchOpenTimeLog">
			</field>

			<div v-if="localClockIn">

				<h3>Clock In</h3>

				<job-picker
					v-if="!payload.service_id"
					col-class="col-md-4" 
					job-type="project"
					v-model="payload.job_id"
					v-on:change="fetchJobPayBoosts">
				</job-picker>

				<job-picker
					v-if="!payload.job_id"
					col-class="col-md-4" 
					job-type="service"
					v-model="payload.service_id"
					v-on:change="fetchJobPayBoosts">
				</job-picker>
			</div>
			<div v-else-if="record.Job || record.Service">

				<h3>Clock Out</h3>

				<form-group :label="record.job_id > 0 ? 'Project' : 'Service'" col-class="col-md-4">
					<div class="form-control-plaintext">
						<template v-if="record.job_id > 0">{{ record.Job.job_num }}: {{ record.Job.job_name }}</template>
						<template v-else-if="record.service_id > 0">{{ record.Service.job_num }}: {{ record.Service.customer_name_cache }}</template>
					</div>
				</form-group>

				<field
					label="Regular Hours"
					col-class="col-md-4"
					v-model="payload.regular_hours">
				</field>

				<field v-if="$store.timeLogSettings.uses_overtime_15x == 1"
					label="Overtime x1.5"
					col-class="col-md-4"
					v-model="payload.overtime_hours_15x"
					:params="{'type': 'number',min:0,max:24,step:0.25}">
				</field>

				<field v-if="$store.timeLogSettings.uses_overtime_2x == 1"
					label="Overtime x2.0"
					col-class="col-md-4"
					v-model="payload.overtime_hours_2x"
					:params="{'type': 'number',min:0,max:24,step:0.25}">
				</field>

				<field v-if="$store.timeLogSettings.uses_overtime_25x == 1"
					label="Overtime x2.5"
					col-class="col-md-4"
					v-model="payload.overtime_hours_25x"
					:params="{'type': 'number',min:0,max:24,step:0.25}">
				</field>

				<field
					label="Reason Not On Site"
					col-class="col-md-4"
					v-model="payload.reason_not_on_site"
					:params="{'type': 'textarea'}">
				</field>

			</div>
		</template>
		<template v-else>
			<field
				label="User"
				v-model="payload.user_id"
				col-class="col-md-4"
				:params="{type:'select',options:userOptions(false),required:true}">
			</field>

			<field
				label="Date"
				v-model="logDate"
				col-class="col-md-4"
				:params="{type:'date',required:true}">
			</field>

			<field
				label="Time In"
				v-model="timeIn"
				col-class="col-md-4"
				:params="{type:'time',required:true}">
			</field>

			<field
				label="Time Out"
				v-model="timeOut"
				col-class="col-md-4"
				:params="{type:'time',required:true}">
			</field>

			<template v-if="!projectOrService">
				<job-picker
					v-if="!payload.service_id"
					col-class="col-md-4" 
					:required="true"
					v-model="payload.job_id"
					job-type="project"
					key="project"
					v-on:change="fetchJobPayBoosts">
				</job-picker>

				<job-picker
					v-if="!payload.job_id"
					col-class="col-md-4" 
					:required="true"
					v-model="payload.service_id"
					key="service"
					job-type="service"
					v-on:change="fetchJobPayBoosts">
				</job-picker>
			</template>

			<field
				label="Regular Hours"
				col-class="col-md-4"
				:params="{'type': 'number',min:0,max:24,step:0.25}"
				v-model="payload.regular_hours">
			</field>

			<field v-if="$store.timeLogSettings.uses_overtime_15x == 1"
				label="Overtime x1.5"
				col-class="col-md-4"
				v-model="payload.overtime_hours_15x"
				:params="{'type': 'number',min:0,max:24,step:0.25}">
			</field>

			<field v-if="$store.timeLogSettings.uses_overtime_2x == 1"
				label="Overtime x2.0"
				col-class="col-md-4"
				v-model="payload.overtime_hours_2x"
				:params="{'type': 'number',min:0,max:24,step:0.25}">
			</field>

			<field v-if="$store.timeLogSettings.uses_overtime_25x == 1"
				label="Overtime x2.5"
				col-class="col-md-4"
				v-model="payload.overtime_hours_25x"
				:params="{'type': 'number',min:0,max:24,step:0.25}">
			</field>

			<field v-if="payBoostOptions.length > 0"
				label="Pay Adjustments Applied"
				col-class="col-md-4"
				:params="{type:'select-multi',options:payBoostOptions}"
				v-model="payload.PayBoost">
			</field>

			<field
				label="Reason Not On Site"
				col-class="col-md-4"
				v-model="payload.reason_not_on_site"
				:params="{'type': 'textarea'}">
			</field>

		</template>
	</modal-dialog>
</template>
<script type="text/javascript">
import ModalDialog from "../ModalDialog"
import Field from "../Field"
import FormGroup from "../FormGroup"
import JobPicker from "@/components/super_components/JobPicker"


export default {
	name: "TimeLogManualEntryModal",
	components: {
		ModalDialog,
		Field,
		FormGroup,
		JobPicker
	},
	props: ["visible","title","recordType","clockIn","projectOrService","jobId"],
	data() {
		return {
			payload: {},
			record: {},
			logDate: null,
			timeIn: null,
			timeOut: null,
			user_id: null,
			localClockIn: this.clockIn,
			payBoosts: []
		}
	},
	watch: {
		visible() {
			if (this.visible) {

				//check to see if required lists exists, otherwise fetch them
				if (Object.keys(this.$store.timeLogSettings).length == 0 ||
					this.$store.services.length == 0 ||
					this.$store.projects.length == 0 ||
					this.$store.users.length == 0) {

					this.fetchData()
				}

				if (this.projectOrService && this.jobId) {
					if (this.projectOrService == "project") {
						this.payload.job_id = this.jobId
						this.payload.service_id = 0
					}
					else if (this.projectOrService == "service") {
						this.payload.service_id = this.jobId
						this.payload.job_id = 0
					}
				}
			}
		}
	},
	computed: {
		payBoostOptions() {
			if (this.payBoosts)
				return this.optionify(this.payBoosts,"description")
			else
				return []
		}
	},
	methods: {
		closeModal() {
			this.payload = {}
			this.record = {}
			this.user_id = null

			this.$emit("closeModal")
		},
		saveTimeLog() {
			let vm = this

			if (this.projectOrService == "service") {
				this.payload.service_id = this.jobId
				this.payload.job_id = 0
			}
			else if (this.projectOrService == "project") {
				this.payload.job_id = this.jobId
				this.payload.service_id = 0
			}

			if (this.recordType == "clockIn") {

				if (!this.localClockIn) {
					this.payload.id = this.record.id
					this.payload.request = "clockOut"
				}

				this.postData("TimeLog/punch-clock",this.payload,true).then(response => {
					if (response.success) {
						vm.closeModal()
						vm.alertSaved("Time Log posted")
						vm.$emit("modelChange")
					}
				})
			}
			else {

				let timeInUTC = this.moment(this.logDate + " " + this.timeIn).utc()
				let timeOutUTC = this.moment(this.logDate + " " + this.timeOut).utc()

				if (timeInUTC.isAfter(timeOutUTC))
					timeOutUTC.add(1,"days")

				//combine logDate and timeIn/Out fields
				this.payload.time_in = timeInUTC.format("YYYY-MM-DD HH:mm:00")
				this.payload.time_out = timeOutUTC.format("YYYY-MM-DD HH:mm:00")

				this.saveRecord("TimeLog",this.payload, response => {
					vm.alertSaved("Time Log posted")
					vm.closeModal()
					vm.$emit("modelChange")
					vm.$bus.$emit("timeLogSaved", {})
				})
			}
		},
		fetchData() {
			let vm = this

			let promises = [
				this.getJSON("TimeLogSetting/get"),
				this.fetchUsers([],false,["first_name","last_name","email"]),
			]

			this.spinner(true)

			Promise.all(promises).then(responses => {
				vm.spinner(false)

				vm.$store.timeLogSettings = responses[0].data[0]
			})
		},
		fetchJobPayBoosts() {
			let vm = this

			let params = {}

			if (this.payload.job_id > 0) {
				params.include = ["Job"]
				params.filters = [["Job.id",this.payload.job_id]]
			}
			else if (this.payload.service_id > 0) {
				params.include = ["Service"]
				params.filters = [["Service.id",this.payload.job_id]]
			}

			this.getJSON("PayBoost/get",params).then(response => {
				vm.payBoosts = response.data
			})
		},
		fetchOpenTimeLog() {
			let vm = this

			this.$nextTick(() => {

				let params = {
					include: [
						"Job",
						{
							model: "Service",
							include: ["Contact"]
						}
					],
					filters: [
						["user_id",this.user_id]
					]
				}

				this.getJSON("OpenTimeLog/get",params,true).then(response => {

					//if no record, then this will be a clock in
					if (response.data.length == 0) {
						vm.localClockIn = true
						vm.payload = {
							job_id: vm.record.job_id,
							service_id: vm.record.service_id,
							user_id: vm.user_id
						}
					}
					else {
						vm.localClockIn = false

						vm.record = response.data[0]

						vm.payload = {
							id: vm.record.id,
							job_id: vm.record.job_id,
							service_id: vm.record.service_id,
							user_id: vm.record.user_id,
							regular_hours: 0,
							overtime_hours_15x: 0,
							overtime_hours_2x: 0,
							overtime_hours_25x: 0,
							reason_not_on_site: ""
						}
					}
				})
			})
		}
	}

}
</script>